import React from 'react';
import { MapPin, Phone, Mail, Calendar } from 'lucide-react';
import { Button } from '../ui/Button';
import { LocationData } from '../../data/locations';
interface LocationPageHeroProps {
  location: LocationData;
}
export function LocationPageHero({
  location
}: LocationPageHeroProps) {
  const scrollToContact = () => {
    const contactForm = document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const scrollToSchedule = () => {
    const scheduleSection = document.getElementById('schedule-section');
    if (scheduleSection) {
      scheduleSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-[500px] flex items-center overflow-hidden" data-id="element-589">
      {/* Background Image */}
      {location.heroImage && <div className="absolute inset-0 z-0" data-id="element-590">
          <img src={location.heroImage} alt={`${location.name} Training Facility`} className="w-full h-full object-cover object-center" data-id="element-591" />
          {/* Dark overlay for text readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40" data-id="element-592"></div>
        </div>}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10 w-full" data-id="element-593">
        <div className="max-w-2xl" data-id="element-594">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 drop-shadow-lg" data-id="element-595">
            {location.name}
          </h1>

          <div className="space-y-3 mb-8" data-id="element-596">
            <div className="flex items-start text-white" data-id="element-597">
              <MapPin className="h-5 w-5 mr-3 flex-shrink-0 mt-1" data-id="element-598" />
              <span className="text-lg drop-shadow-md" data-id="element-599">{location.address}</span>
            </div>

            <div className="flex items-center text-white" data-id="element-600">
              <Phone className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-601" />
              <a href={`tel:${location.phone.replace(/\D/g, '')}`} className="text-lg hover:text-slate-200 transition-colors drop-shadow-md" data-id="element-602">
                {location.phone}
              </a>
            </div>

            {location.email && <div className="flex items-center text-white" data-id="element-603">
                <Mail className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-604" />
                <a href={`mailto:${location.email}`} className="text-lg hover:text-slate-200 transition-colors drop-shadow-md" data-id="element-605">
                  {location.email}
                </a>
              </div>}
          </div>

          <div className="flex flex-col sm:flex-row gap-3" data-id="element-606">
            <Button variant="primary" size="lg" className="shadow-2xl whitespace-nowrap" data-id="element-607">
              Get 2 Weeks Free
            </Button>
            <Button variant="outline" size="lg" className="bg-white/10 border-white text-white hover:bg-white hover:text-slate-900 backdrop-blur-sm whitespace-nowrap" onClick={scrollToSchedule} data-id="element-608">
              <Calendar className="h-5 w-5 mr-2 flex-shrink-0" data-id="element-609" />
              View Schedule
            </Button>
            <Button variant="outline" size="lg" className="bg-white/10 border-white text-white hover:bg-white hover:text-slate-900 backdrop-blur-sm whitespace-nowrap" onClick={scrollToContact} data-id="element-610">
              Contact This Location
            </Button>
          </div>
        </div>
      </div>
    </section>;
}